<template>
  <div class="ListEquipamentos">
    <HeaderPage> </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBox
        v-on:filter="listDados"
        v-on:filterExport="exportDados"
        :currentPage="listData.meta ? listData.meta.pagination.current_page : 1"
      />
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import FilterBox from "@/app/domains/Report/components/Equipment/_filterBox";
import { getEquipamentos, getExportEquipamentos } from "@/app/domains/Report/services";
export default {
  name: "ListEquipamentos",
  components: {
    HeaderPage,
    FilterBox,
  },
  data() {
    return {
      loadingPage: false,
      listData: {},
    };
  },
  methods: {
    init() {
      this.listDados();
    },
    paginationClick(arg) {
      this.listDados("?page=" + arg.page);
    },
    async exportDados(arg) {
      this.loadingPage = true;
      try {
        let response = await getExportEquipamentos(arg);
        window.open(response.data, "_blank");
      } catch (e) {
        let mensagem = "Nenum equipamento encontrado";
        if (e.message != undefined) {
          mensagem = e.message;
        }
        console.log(e);
        if (e.body[0].messages != undefined) {
          mensagem = e.body[0].messages;
        }
        this.$message({
          showClose: true,
          message: mensagem,
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
    async listDados(query = "") {
      this.loadingPage = true;
      try {
        let response = await getEquipamentos(query);
        this.listData = response.data;
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
